// @ts-nocheck
import React, { useEffect } from 'react';

import { connect } from 'react-redux';
import { signinRedirect, getUser } from '../../services/userService';
import { useTranslation } from 'react-i18next';
import { showLoader, hideLoader } from '../../actions/loaderActions';
import { toast } from 'react-toastify';
import { usePageVisibility } from '../../hooks/usePageVisibility';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../hooks';
import {
  clearUserProperties,
  fetchAndStoreUser,
} from '../../reducers/authReducer';
import { pageActive, pageInactive } from '../../middleware/signalRMiddleware';

function MustAuth({ children, hideLoader, showLoader, storeUser }) {
  const currentUser = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (currentUser == null) {
      getUser().then((user) => {
        if (!user || user.expired) {
          signinRedirect(`${location.pathname}${location.search}`).catch(
            (e) => {
              navigate('/Access-Denied');
            }
          );
        } else {
          dispatch(fetchAndStoreUser(user));
        }
      });
    }

    if (currentUser?.accessDenied) {
      dispatch(clearUserProperties()).then(() => navigate('/Access-Denied'));
    } else if (currentUser?.apiFailure) {
      dispatch(clearUserProperties()).then(() => navigate('/Api-Failure'));
    } else if (currentUser?.trialEnded) {
      dispatch(clearUserProperties()).then(() => navigate('/trial-ended'));
    } else if (currentUser?.permissionsChanged) {
      dispatch(clearUserProperties()).then(() =>
        toast.warning(t('Your permissions have been updated'))
      );
    } else if (currentUser?.isLoading) {
      showLoader('ALASKA', t('loading...'));
      console.log(
        `%c ##################################### \n        %cALASKA ©${new Date().getFullYear()} - %cK3YS LTD        %c\n ##################################### `,
        'background: #252628; color: #ff006e',
        'background: #252628; color: #ffffff',
        'background: #252628; color: #ffff00',
        'background: #252628; color: #ff006e'
      );
      console.log(
        '%c                                      \n' +
          ' (((((((((((((((((((((((((((((((((((( \n' +
          ' (((((((((((((((((((((((((((((((((((( \n' +
          ' (((((((((((((((((((((((((((((((((((( \n' +
          ' ((((((((%c@@#%c((%c&@@%c(((((%c@@&&@@%c((((((((( \n' +
          ' ((((((((%c@@#%c(%c&@@%c((((((((((%c@@#%c(((((((( \n' +
          ' ((((((((%c@@@@@%c((((((((((%c%&@@%c((((((((( \n' +
          ' ((((((((%c@@#@@@%c((((((((((((%c@@%c(((((((( \n' +
          ' ((((((((%c@@#%c((%c&@@%c(((((%c@@@@@@#%c(((((((( \n' +
          ' (((((((((((((((((((((((((((((((((((( \n' +
          ' ((((((((%c@@#%c((((%c@@%c(((((%c@@@@#%c((((((((( \n' +
          ' (((((((((%c#@@%c(%c#@&%c(((((%c@@%c((((((((((((( \n' +
          ' (((((((((((%c@@@%c((((((((%c&@@@#%c((((((((( \n' +
          ' ((((((((((((%c@#%c(((((((%c@%c((((%c@@%c(((((((( \n' +
          ' ((((((((((((%c@#%c((((((((%c@@@@#%c((((((((( \n' +
          ' (((((((((((((((((((((((((((((((((((( \n' +
          ' (((((((((((((((((((((((((((((((((((( \n' +
          '                                      ',
        'background: #2a2b2e; color: #16beef',
        'background: #2a2b2e; color: #ffffff',
        'background: #2a2b2e; color: #16beef',
        'background: #2a2b2e; color: #ffffff',
        'background: #2a2b2e; color: #16beef',
        'background: #2a2b2e; color: #ffffff',
        'background: #2a2b2e; color: #16beef',
        'background: #2a2b2e; color: #ffffff',
        'background: #2a2b2e; color: #16beef',
        'background: #2a2b2e; color: #ffffff',
        'background: #2a2b2e; color: #16beef',
        'background: #2a2b2e; color: #ffffff',
        'background: #2a2b2e; color: #16beef',
        'background: #2a2b2e; color: #ffffff',
        'background: #2a2b2e; color: #16beef',
        'background: #2a2b2e; color: #ffffff',
        'background: #2a2b2e; color: #16beef',
        'background: #2a2b2e; color: #ffffff',
        'background: #2a2b2e; color: #16beef',
        'background: #2a2b2e; color: #ffffff',
        'background: #2a2b2e; color: #16beef',
        'background: #2a2b2e; color: #ffffff',
        'background: #2a2b2e; color: #16beef',
        'background: #2a2b2e; color: #ffffff',
        'background: #2a2b2e; color: #16beef',
        'background: #2a2b2e; color: #ffffff',
        'background: #2a2b2e; color: #16beef',
        'background: #2a2b2e; color: #ffffff',
        'background: #2a2b2e; color: #16beef',
        'background: #2a2b2e; color: #ffffff',
        'background: #2a2b2e; color: #16beef',
        'background: #2a2b2e; color: #ffffff',
        'background: #2a2b2e; color: #16beef',
        'background: #2a2b2e; color: #ffffff',
        'background: #2a2b2e; color: #16beef',
        'background: #2a2b2e; color: #ffffff',
        'background: #2a2b2e; color: #16beef',
        'background: #2a2b2e; color: #ffffff',
        'background: #2a2b2e; color: #16beef',
        'background: #2a2b2e; color: #ffffff',
        'background: #2a2b2e; color: #16beef',
        'background: #2a2b2e; color: #ffffff',
        'background: #2a2b2e; color: #16beef',
        'background: #2a2b2e; color: #ffffff',
        'background: #2a2b2e; color: #16beef',
        'background: #2a2b2e; color: #ffffff',
        'background: #2a2b2e; color: #16beef',
        'background: #2a2b2e; color: #ffffff',
        'background: #2a2b2e; color: #16beef',
        'background: #2a2b2e; color: #ffffff',
        'background: #2a2b2e; color: #16beef',
        'background: #2a2b2e; color: #ffffff',
        'background: #2a2b2e; color: #16beef'
      );
      return;
    }
    setTimeout(hideLoader, 1500);
  }, [
    currentUser,
    location.pathname,
    location.search,
    hideLoader,
    showLoader,
    storeUser,
    t,
    navigate,
    dispatch,
  ]);

  const isVisible = usePageVisibility();

  useEffect(() => {
    if (isVisible) {
      dispatch(pageActive());
    } else {
      dispatch(pageInactive());
    }
  }, [dispatch, isVisible]);

  return currentUser == null ? '' : React.Children.only(children);
}

const mapDispatchToProps = {
  showLoader,
  hideLoader,
};

export default connect(null, mapDispatchToProps)(MustAuth);
